import { Link } from 'react-router-dom';
import { AI_SATEI_URL, AT_HOME_URL, COMPANY } from '@/constants/company';

const serviceLinks = [
  { label: 'サービス', path: '/services' },
  { label: '名古屋16区に強い理由', path: '/regional' },
  { label: 'お客様の声', path: '/testimonials' },
  { label: 'よくある質問', path: '/faq' },
];

const companyLinks = [
  { label: '会社概要', path: '/company' },
  { label: '物件一覧', path: '/listings' },
  { label: 'お問い合わせ', path: '/contact#form' },
  { label: 'プライバシーポリシー', path: '/privacy' },
];

export default function Footer() {
  return (
    <footer className="bg-[#F8F9FB] border-t border-gray-200">
      {/* Footer Main */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 bg-[#1A2B4A] rounded flex items-center justify-center">
                <span className="text-white text-xs font-bold">CC</span>
              </div>
              <span className="font-bold text-[#1A2B4A] text-sm">{COMPANY.name}</span>
            </div>
            <p className="text-gray-500 text-sm leading-relaxed mb-4">
              名古屋16区に強い不動産会社。<br />
              売却・買取・相談、全国どこからでもお気軽にどうぞ。
            </p>
            <p className="text-gray-400 text-xs">{COMPANY.zip} {COMPANY.address}</p>
            <p className="text-gray-400 text-xs mt-1">TEL: {COMPANY.tel}</p>
            <p className="text-gray-400 text-xs mt-1">営業時間: {COMPANY.hours}</p>
          </div>

          {/* Service Links */}
          <div>
            <h3 className="text-[#1A2B4A] font-semibold text-sm mb-5">サービス・情報</h3>
            <ul className="space-y-3">
              {serviceLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-500 text-sm hover:text-[#1A2B4A] transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={AT_HOME_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-500 text-sm hover:text-[#1A2B4A] transition-colors duration-200 cursor-pointer"
                >
                  販売中の物件（アットホーム）
                </a>
              </li>
            </ul>
          </div>

          {/* Company Links */}
          <div>
            <h3 className="text-[#1A2B4A] font-semibold text-sm mb-5">会社情報</h3>
            <ul className="space-y-3">
              {companyLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-500 text-sm hover:text-[#1A2B4A] transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-[#1A2B4A] font-semibold text-sm mb-5">お問い合わせ</h3>
            <a
              href={COMPANY.telHref}
              className="flex items-center gap-2 text-[#1A2B4A] font-bold text-xl mb-1 cursor-pointer hover:text-[#4A90E2] transition-colors duration-200"
            >
              <i className="ri-phone-line" />
              {COMPANY.tel}
            </a>
            <p className="text-gray-400 text-xs mb-5">営業時間 {COMPANY.hours}</p>
            <a
              href={AI_SATEI_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-[#1A2B4A] text-white text-sm text-center py-3 px-4 rounded-lg font-medium whitespace-nowrap hover:bg-[#243d6b] transition-colors duration-200 cursor-pointer mb-3"
            >
              AI査定をはじめる
            </a>
            <Link
              to="/contact#form"
              className="block border border-[#1A2B4A] text-[#1A2B4A] text-sm text-center py-3 px-4 rounded-lg font-medium whitespace-nowrap hover:bg-[#F0F4FA] transition-colors duration-200 cursor-pointer"
            >
              お問い合わせ
            </Link>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-gray-400 text-xs">
            © {new Date().getFullYear()} {COMPANY.name}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/privacy" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">
              プライバシーポリシー
            </Link>
            <span className="text-gray-300 text-xs">|</span>
            <Link to="/privacy" className="text-gray-400 text-xs hover:text-gray-600 cursor-pointer">
              免責事項
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
